<template>
  <b-container id="landingPageCategoryDetail">
    <b-row>
      <b-col class="group-header">
        <h1>{{ title }}</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col id="sections">
        <LandingPageCategorySection
          v-for="section in sections"
          :key="section._id"
          :section="section"
        />
        <h3 class="noItems" v-if="sectionsLength === 0">
          No items to list
        </h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <router-link
          class="btn btn-dark mr-2"
          :to="{ name: 'landingPageCategories' }"
        >
          BACK TO LANDING PAGE
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import LandingPageCategorySection from '@/components/Front/landing/LandingPageCategorySection'

const landingPageCategoryStore = namespace('landingPageCategoryStore')
const landingPageCategoryDetailStore = namespace(
  'landingPageCategoryDetailStore'
)
const landingSectionStore = namespace('landingSectionStore')
const genderStore = namespace('genderStore')

@Component({
  components: {
    LandingPageCategorySection
  }
})
export default class LandingPageCategoryDetail extends Vue {
  @Prop({ type: String, required: true, default: null }) landingPageCategoryId
  @Prop({ type: String, required: true, default: null }) genderId

  @landingPageCategoryStore.Action('fetchItem') actionFetchLandingPageCategory
  @landingPageCategoryStore.State('item') landingPageCategory

  @landingPageCategoryDetailStore.Action('fetchItem') actionFetchItem
  @landingPageCategoryDetailStore.State('item') landingPageCategoryDetail

  @landingSectionStore.Action('fetchItems') actionFetchSections
  @landingSectionStore.Getter('publishedItems') sections

  @genderStore.Action('fetchItems') actionFetchGender
  @genderStore.Getter('getById') getGenderbyId

  /**
   * Hook: created
   * Initialize the pre data. It dispatch multiple store actions to each api service
   */
  created() {
    this.actionFetchGender()

    const landingPageCategoryId = this.landingPageCategoryId
    const genderId = this.genderId

    this.actionFetchLandingPageCategory(this.landingPageCategoryId)

    this.actionFetchItem({ landingPageCategoryId, genderId }).then(item => {
      if (item) {
        this.actionFetchSections(item._id)
      }
    })
  }

  get title() {
    if (this.landingPageCategoryDetail.title) {
      return this.landingPageCategoryDetail.title
    } else {
      return 'loading'
    }
  }

  get genderName() {
    const gender = this.getGenderbyId(this.genderId)
    if (gender) {
      return gender.name
    }
    return 'Loading gender'
  }

  get sectionsLength() {
    return this.sections ? this.sections.length : 0
  }
}
</script>

<style lang="scss" scoped>
#landingPageCategoryDetail {
  padding: 0;
  margin: 20px auto 0;
  max-width: none;
}
#sections {
  .noItems {
    text-align: center;
    padding: 20px;
  }
}
</style>
